import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Pill } from '@one-thd/sui-atomic-components';
import { track } from './related-search-analytics';

const RelatedSearchLinks = (props) => {
  const {
    relatedLinks,
    title
  } = props;

  const renderRelatedSearch = (relatedSearchResults) => {
    let url = '';

    const handleRelatedSearchClick = (copyText) => {
      if (window?.LIFE_CYCLE_EVENT_BUS) {
        window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('related-search.UPDATE', { updatedSearchTerm: copyText });
      }
      track(copyText);
    };

    return (
      <div
        className="related-search__links sui-flex sui-flex-row sui-flex-wrap sui-leading-tight sui-gap-4"
      >
        {relatedSearchResults.map((relatedSearchResult, index) => {
          url = relatedSearchResult.url || (`/s/${encodeURIComponent(relatedSearchResult.keyword)}`);
          const copyText = relatedSearchResult.anchor || relatedSearchResult.keyword;

          return (
            <div
              className="related-search__elements sui-bg-primary sui-rounded-full"
              key={`relatedSearchResult-${copyText}${index}`}
            >
              <Pill
                label={copyText}
                component="a"
                href={url}
                onClick={() => handleRelatedSearchClick(copyText)}
                clickable
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="sui-w-full sui-flex sui-flex-col sui-gap-4">
      <Typography variant="h2" weight="display">{title}</Typography>
      {renderRelatedSearch(relatedLinks)}
    </div>
  );
};

export { RelatedSearchLinks };

RelatedSearchLinks.propTypes = {
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      anchor: PropTypes.string,
      url: PropTypes.string
    })
  ).isRequired,
  title: PropTypes.string
};

RelatedSearchLinks.defaultProps = {
  title: 'Related Searches'
};
